/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_SubtitleInputs */

const vi_my_grower_report_subtitle = /** @type {(inputs: My_Grower_Report_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lượng phân bón, thuốc đã dùng và tiền chè hộ đã nhận`)
};

/**

* @param {My_Grower_Report_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_subtitle = /** @type {((inputs?: My_Grower_Report_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_subtitle(inputs)
});